const pick = (val: string | undefined, fallback: string) =>
  val && val.trim() !== "" ? val : fallback;

const WS_CHAT_URL = pick(process.env.REACT_APP_WS_CHAT_URL, "ws://localhost:9091");

const VOICE_URL = pick(process.env.REACT_APP_VOICE_URL, "wss://localhost:9091");

const RAW_SERVICES_BASE_URL = pick(
  process.env.REACT_APP_SERVICES_BASE_URL,
  "https://services.infinity-copilot.com"
);

const SERVICES_BASE_URL = RAW_SERVICES_BASE_URL.replace(/\/+$/, "");

const GOOGLE_AUTH_PROVIDER = pick(
  process.env.REACT_APP_GOOGLE_AUTH_PROVIDER,
  "118765014588-hq8sia97shuevajp11obe2qqlhk1s0rp.apps.googleusercontent.com"
);

export { GOOGLE_AUTH_PROVIDER, SERVICES_BASE_URL, VOICE_URL, WS_CHAT_URL };
